<sc-padding [fitHeight]="true">
    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
        <form [formGroup]="formGroup">
            <mat-slide-toggle formControlName="hasParameter" name="hasParameter">
                {{'hasParameter' | translate:
                ['tmc-yard.entity.transport-option.has-parameter',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-dictionary-field [model]="transportOption.parameterName" [maxlength]="255" defaultLabel="Name"
                labelDictionaryKey="tmc-yard.entity.transport-option.parameter-name"
                (dictionaryChanged)="onParameterNameChanged($event)" [disabled]="!transportOption.hasParameter">
            </sc-dictionary-field>
        </form>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-sub-title>{{'Values' | translate:
            ['tmc-yard.entity.transport-option.parameter-values',
            translationService.language]}}</sc-sub-title>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex-fitting-content [vertical]="true">
            <sc-scroll-pane>
                <ng-container *ngFor="let value of visibleParameterValues; let i = index">
                  <sc-content-spacer [half]="true" [vertical]="true" *ngIf="i > 0"></sc-content-spacer>
                  <sc-data-set-tile
                      [light]="i % 2 === 0"
                      [selected]="currentEditingParameterValue === value">
                      <sc-padding>
                          <sc-flex
                              *ngIf="currentEditingParameterValue == null || currentEditingParameterValue !== value">
                              <app-dictionary-entry-label [model]="value.value"></app-dictionary-entry-label>
                              <sc-content-spacer [grow]="true"></sc-content-spacer>
                              <sc-action-icon iconClass="fa-pencil" (click)="editParameterValue(value)"></sc-action-icon>
                              <sc-content-spacer></sc-content-spacer>
                              <sc-action-icon iconClass="fa-trash" (click)="deleteParameterValue(value)"></sc-action-icon>
                          </sc-flex>
                          <form *ngIf="currentEditingParameterValue === value" class="no-field-space">
                              <sc-flex >
                                  <sc-dictionary-field [grow]="true" [model]="currentEditingParameterValue.value" [maxlength]="255"
                                      defaultLabel="Wert"
                                      labelDictionaryKey="tmc-yard.ui.admin.transport-options-administration.parameter-value"
                                      (dictionaryChanged)="onParameterValueChanged($event)">
                                  </sc-dictionary-field>
                                  <sc-content-spacer></sc-content-spacer>
                                  <sc-icon iconClass="fa-times" (click)="unselectParameterValue()"></sc-icon>
                              </sc-flex>
                          </form>
                      </sc-padding>
                  </sc-data-set-tile>
                </ng-container>
            </sc-scroll-pane>
        </sc-flex-fitting-content>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div>
            <sc-flex [centered]="true">
                <button mat-flat-button [disabled]="!transportOption.hasParameter"
                    (click)="addParameterValue()">{{'Add' | translate:
                    ['tmc-yard.action.add',
                    translationService.language]}}</button>
            </sc-flex>
        </div>
    </sc-flex>
</sc-padding>
